<dcp-edit-cart-entry
  *ngIf="!configureServiceError"
  (addedToCart)="addedToCart.emit()"
  (finishedLoading)="finishedLoading.emit($event)"
  (triggerClose)="triggerClose.emit()"
  [editMode]="true"
  [cartEntry]="cartEntry"
  [isModalOpened]="isModalOpened"
  [forceModal]="forceModal"
></dcp-edit-cart-entry>
<dcp-configure-service-error
  (configureServiceError)="processConfigureServiceError($event)"></dcp-configure-service-error>
<dcp-footer-container></dcp-footer-container>
